import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full pt-3" }
const _hoisted_2 = ["href", "innerHTML"]

import { onMounted, ref } from 'vue';
import { useAccountStore } from '@/store';
import { InsurancePolicy } from '@/interfaces';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentDueLinks',
  props: {
    insurancePolicy: {},
    item: {},
    selfServiceToggles: {}
  },
  setup(__props: any) {

const accountStore = useAccountStore();

const props = __props;

const makePaymentUrl = ref<string>();

onMounted(async () => {
  makePaymentUrl.value = await getMakePaymentUrl();
});

const getMakePaymentUrl = async (): string => {
  const selfServiceMakePaymentUrl = await accountStore.getSelfServiceMakePaymentUrl();
  const paymentReferenceNumber = props.insurancePolicy?.currentTermPaymentDetails?.paymentReferenceNumber;
  return `${selfServiceMakePaymentUrl?.replace('{0}', paymentReferenceNumber)}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, [
      _createElementVNode("a", {
        href: makePaymentUrl.value,
        class: "btn btn-primary btn-sm !py-[0.375rem] text-base inline cursor-pointer",
        innerHTML: _ctx.item.firstLinkContent.value
      }, null, 8, _hoisted_2)
    ])
  ]))
}
}

})